module.exports = __webpack_public_path__ + "static/media/teygja_kalfapressa_a.8ed29ec1.png";